module.exports = __webpack_public_path__ + "img/icon-check.2166b2a1.png";